// extracted by mini-css-extract-plugin
export default {"root":"FormImg_root__3QazR"};